// Importing Foundation first
// ### Core
import $ from 'jquery';
import './global/foundation';
import 'what-input';

// Load foundation with Drupal BigPipe Support
(function ($, Drupal) {
  Drupal.behaviors.LoadFoundation = {
    attach: function (context, settings) {
      $(context).foundation();
    }
  }
})(jQuery, Drupal);


// Import all your components here
// But don't code inside this file.
import './utils/polyfills';
import './utils/videos';
import './utils/tables';
// import './utils/youtubeIframe';

// Components
import './components/fixedNav';
import './components/imageLoop';
import './components/lazyLoad';
import './components/mainMenu';
import './components/mobileMenu';
import './components/smoothScroll';
import './components/swiper';
import './components/toggler';
import './components/tooltip';
import './components/autocomplete';
import './components/facets';
import './components/search';
import './components/select2';
import './components/select';

// Enables HMR for JS files imported here
if (module.hot) {
  module.hot.accept();
}

// Signed by Choosit!
// eslint-disable-next-line no-console
console.log(`%c Made with ❤️ by Choosit! `, `background-color: #009ee0; color: white;`);
